import React, { useMemo, useState } from "react"
import { RouteComponentProps, useParams } from "react-router-dom"
import { Alert, Button, Col, Divider, Form, Input, Row, Switch } from "antd"
import SettingsPageEdit from "components-old/common/SettingsPage/SettingsPageEdit"
import { useStore, useStoreState } from "hooks"
import { IChannel } from "models/channels"
import { ChannelStatus } from ".."
import WhatsappSvg from "../svgs/WhatsappSvg"
import TextArea from "antd/lib/input/TextArea"
import { WHATSAPP_CLOUD_API_WEBHOOK } from "lib/constants"
import copy from "copy-to-clipboard"
import toast from "lib/toast"
import HorizontalSwitch from "components-old/ui/HorizontalSwitch"
import EditEntityCustomFields from "pages/crm/contacts/EditEntityCustomFields"
import GroupsSelect from "components-old/ui/GroupsSelect"
import { isAldeia } from "hooks/useAldeia"
import WhatsappTemplatesDrawer from "./WhatsappTemplatesDrawer"
import { useSetAtom } from "jotai"
import { modalState } from "atoms/app.atom"
import { session } from "store"
import { verifyPermission } from "lib/helper"

interface IEditEmailProps extends RouteComponentProps<{ id: string }> {
  onChange: Function
}

function EditWhatsappCloud(props: IEditEmailProps) {
  const [form] = Form.useForm()
  const { all: channels } = useStoreState((state) => state.channels)
  const { id } = useParams<any>()
  const [item, setItem] = useState<IChannel>()
  const [templatesVisible, setTemplatesVisible] = useState(false)
  const setModal = useSetAtom(modalState)

  const channel = useMemo(() => {
    return channels.find((c) => c.id == id)
  }, [channels, id])

  const isNotEmbedded = !!item && !item?.extraData?.signUpData

  return (
    <SettingsPageEdit<IChannel>
      {...props}
      pageComponent={isAldeia ? "drawer" : "page"}
      routeName="channels"
      title="Canal de Whatsapp Cloud API"
      onChangeItem={(item) => setItem(item)}
      forceModelOnly
      onSubmitBefore={(model, onSubmit) => {
        if (verifyPermission("channel_only_simple_maintenance", { restrictive: true })) {
          toast.error("Você não tem permissão para dar editar o canal")
          throw new Error("Somente pode dar manutenção simples em canais")
        }

        return onSubmit({
          id,
          description: model.description,
          disable_active_chat: model.disable_active_chat,
          isPrivate: model.isPrivate,
          groupIds: model.groupIds,
          ...(isNotEmbedded
            ? {
                hashIdentifier: (model as any).hashIdentifier,
                identifier: (model as any).identifier,
              }
            : {}),
        })
      }}
      onSubmitSuccess={() => {
        props.onChange()
      }}
      width={500}
      stickyFooter={isAldeia}
      titleOverwrite={
        <Row justify="space-between" align="middle" wrap={false}>
          <Col>
            <Row wrap={false}>
              <Col>
                <div
                  style={{
                    width: 24,
                    height: 24,
                    display: "flex",
                    marginRight: 10,
                  }}
                >
                  <WhatsappSvg />
                </div>
              </Col>
              <Col
                className="truncate"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {channel?.description}
              </Col>
            </Row>
          </Col>
        </Row>
      }
      storePath={(store) => store.channelsWhatsappCloudApi}
      form={form}
      hideFooterWhenSaved
      // defaultValues={{
      //     identifier: shortid.generate() + "kinbox@mail.kinbox.com.br",
      // }}
      formProps={{
        onValuesChange(changedValues, values) {
          if (changedValues?.isPrivate && !form.getFieldValue("groupIds")) {
            form.setFieldsValue({
              groupIds: [],
            })
          }
        },
      }}
    >
      {item?.extraData?.alertMesaage && (
        <Alert
          showIcon
          message={item?.extraData?.alertMesaage}
          description="Em caso de dúvida entre em contato com o nosso suporte"
          type="warning"
        />
      )}
      <Form.Item label="Status">
        <span className="inline-block">
          <ChannelStatus status={channel?.status} />
        </span>
      </Form.Item>
      {/* <Form.Item lx */}
      <Form.Item
        label="Descrição"
        name="description"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input placeholder="Canal de suporte" />
      </Form.Item>
      <Form.Item label="Número" name="phone">
        <Input disabled />
      </Form.Item>

      {isNotEmbedded && (
        <>
          <Form.Item
            label="ID da conta comercial do WhatsApp"
            name="waba_id"
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="Identificação do número de telefone"
            name="identifier"
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="Token"
            name="hashIdentifier"
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <TextArea rows={5} style={{ resize: "none" }} />
          </Form.Item>
          <Form.Item
            label="Webhook"
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input
              value={WHATSAPP_CLOUD_API_WEBHOOK}
              disabled
              suffix={
                <Button
                  icon={<i className="fal fa-copy" />}
                  type="text"
                  onClick={() => {
                    copy(WHATSAPP_CLOUD_API_WEBHOOK)
                    toast.success("Copiado.")
                  }}
                />
              }
            />
          </Form.Item>
        </>
      )}
      <HorizontalSwitch
        title="Apenas Receptivo"
        description="Com essa opção marcada, o canal não pode enviar mensagem ativa e nem ser usado em campanhas."
        name="disable_active_chat"
      />
      <HorizontalSwitch
        title="Restringir visibilidade"
        description="Selecione os grupos que tem acesso a visualizar esse canal"
        name="isPrivate"
      >
        <Form.Item name="groupIds">
          <GroupsSelect mode="multiple" />
        </Form.Item>
      </HorizontalSwitch>
      {isAldeia && !!channel?.extraData?.signUpData?.business_id && (
        <>
          {/* <Divider className="my-10" /> */}
          <div className="card-bordered !border-dashed flex justify-between items-center !bg-selected-lighter-more mt-8">
            <span className="flex items-center gap-3 font-semibold">
              <IconTablerMessage2Bolt className="size-6" />
              Templates
            </span>

            <a
              // href={`https://business.facebook.com/settings/whatsapp/templates/${channel?.extraData?.signUpData?.waba_id}`}
              href={`https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=${channel?.extraData?.signUpData?.business_id}&tab=message-templates`}
              target="_blank"
              rel="noreferrer"
            >
              <Button
                onClick={() => {
                  // setModal(<WhatsappTemplatesDrawer channelId={channel?.id} visible={true} onClose={() => setModal(null)} />)
                }}
                icon={<IconHugeiconsLinkSquare02 className="!size-4" />}
              >
                Gerenciar
              </Button>
            </a>
          </div>
        </>
        // <PreferenceInput title="Templates" description="Gerencie os templates do seu número">
        // </PreferenceInput>
      )}
      {!isAldeia && !isNotEmbedded && (
        <Alert
          message={
            <div
              style={{
                fontSize: 16,
                color: "var(--content-secondary)",
                marginLeft: 5,
                marginBottom: 20,
              }}
            >
              <p>A API Oficial do WhatsApp agora está disponível para qualquer empresa de qualquer tamanho, grande e pequena.</p>
              <br />
              <p>
                <a
                  href="https://kinbox.notion.site/Instala-o-996c0c3974134465ac1a7f239c8f8c0b"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "var(--primary)",
                  }}
                >
                  <i className="fal fa-lightbulb" style={{ marginRight: 5 }} />
                  Clique aqui
                </a>
                {` `}para ver a documentação de como conectar.
              </p>
            </div>
          }
          type="info"
        />
      )}
      <EditEntityCustomFields form={form} item={item} entity="channel" />
      <WhatsappTemplatesDrawer channelId={channel?.id} visible={templatesVisible} onClose={() => setTemplatesVisible(false)} />
    </SettingsPageEdit>
  )
}

export default EditWhatsappCloud
